export default __webpack_public_path__ + "static/media/Img0063.88815ec5.jpg";